import React from 'react';
import * as FaIcons from 'react-icons/fa';

const ReadModal = ({ setModal }) => {
  return (
    <div id='read-modal' className='modal'>
      <div className='modal-content'>
        <div className='top-bar'>
          <FaIcons.FaTimes
            className='close-icon'
            onClick={() => setModal(false)}
          />
          <h2 className='text-center'>Charter School Enrollment Rights</h2>
        </div>
        <div className='body'>
          <h4>California Education Code Requirements</h4>
          <p>
            California Education Code (EC) Section 47605(d)(4)
            <a
              target='_blank'
              href='https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=47605&lawCode=EDC'
            >
              (https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=47605&lawCode=EDC)
            </a>
            states the following:
          </p>
          <p>
            A charter school shall not discourage a pupil from enrolling or
            seeking to enroll in a charter school for any reason, including, but
            not limited to, academic performance of the pupil or because the
            pupil exhibits any of the following characteristics: Academically
            low-achieving, Economically disadvantaged (determined by eligibility
            for any free or reduced-price meal program), English learner,
            Ethnicity, Foster youth, Homeless, Nationality, Neglected or
            delinquent, Race, Sexual orientation, Pupils with disabilities
          </p>
          <p>
            A charter school shall not request a pupil's records or require the
            parent, guardian, or pupil to submit the pupil's records to the
            charter school before enrollment.
          </p>
          <p>
            A charter school shall not encourage a pupil currently attending the
            charter school to dis-enroll from the charter school or transfer to
            another school for any reason (except for suspension or expulsion).
          </p>
          <p>
            This notice shall be posted on a charter school's Internet website
            and a charter school will provide copies of this notice (1) when a
            parent, guardian, or pupil inquiries about enrollment; (2) before
            conducting an enrollment lottery, and (3) before disenrollment of a
            pupil.
          </p>
        </div>
        <div className='bottom-bar'>
          <div onClick={() => setModal(false)} className='btn btn-l4l-green'>
            Close
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadModal;
